import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Container } from '@/components/layout/Container'
import { useCatalogue } from '@/hooks/useCatalogue'
export function Collections() {
  const { collections: apiCollections, loading } = useCatalogue()
  const collections = apiCollections

  return (
    <div className="pt-28 pb-24">
      <Container>
        <p className="mb-4 text-xs uppercase tracking-[0.2em] text-wd-orange">Curated worlds</p>
        <h1 className="mb-4 font-display text-4xl normal-case text-carbon md:text-5xl">
          collections
        </h1>
        <p className="mb-16 max-w-2xl text-carbon/60">
          Each collection is a world. Explore the themes that shape our fragrances.
        </p>

        {loading && collections.length === 0 && (
          <div className="py-20 text-center text-carbon/60">
            <p>Loading collections...</p>
          </div>
        )}

        <div className="grid gap-8 md:grid-cols-2">
          {collections.map((collection, index) => (
            <motion.div
              key={collection.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
            >
              <Link to={`/collections/${collection.slug}`} className="group block">
                <div className="relative aspect-[4/3] overflow-hidden bg-wd-mist">
                  <img
                    src={collection.image}
                    alt={collection.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/80 to-transparent" />
                  <div className="absolute bottom-0 left-0 p-6">
                    <p className="mb-2 text-xs uppercase tracking-[0.15em] text-wd-orange">{collection.tagline}</p>
                    <h2 className="font-display text-3xl normal-case text-white">
                      {collection.name.toLowerCase()}
                    </h2>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </Container>
    </div>
  )
}
